__turbopack_context__.v({
  "item": "BreadcrumbItem-module__dS2q3a__item",
});
